var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIco11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3265 25.8691C22.9771 25.8691 21.8828 26.963 21.8828 28.3129C21.8828 29.2178 22.3762 30.006 23.1075 30.4287V33.1455H25.5456V30.4287C26.2769 30.0061 26.7703 29.2178 26.7703 28.3129C26.7703 26.963 25.6761 25.8691 24.3265 25.8691Z",
    fill: "#2E3A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3283 14.0215C22.2742 14.0215 20.6035 15.6924 20.6035 17.7463V21.713H28.0529V17.7463C28.0527 15.6927 26.382 14.0215 24.3283 14.0215Z",
    fill: "#2E3A59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3277 0.570312C11.3494 0.570312 0.828125 11.0919 0.828125 24.0702C0.828125 37.0482 11.3494 47.5701 24.3277 47.5701C37.3061 47.5701 47.8281 37.0481 47.8281 24.0702C47.8281 11.0919 37.3061 0.570312 24.3277 0.570312ZM31.5486 36.1526H17.1079C15.5829 36.1526 14.3465 34.9161 14.3465 33.3906V24.4732C14.3465 23.1429 15.2876 22.032 16.5403 21.7706V17.7447C16.5403 13.4506 20.0341 9.95652 24.3285 9.95652C28.6227 9.95652 32.1164 13.4502 32.1164 17.7447V21.7706C33.3686 22.0327 34.3098 23.1429 34.3098 24.4732V33.3906H34.3101C34.3101 34.916 33.0736 36.1526 31.5486 36.1526Z",
    fill: "#2E3A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco11);
export default __webpack_public_path__ + "static/media/ico-11.4c256cc8d23f4abf7b555e060effc1c4.svg";
export { ForwardRef as ReactComponent };